import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ImageCard from './ImageCard';

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * LatestPhotosBlock
 * -----------------
 * Dynamic home-page block that surfaces the most recent photo of each unique
 * photographer (deduped by user_id, list sorted latest first). 12 cards.
 * Layout mirrors the admin Featured Blocks for visual consistency.
 */
const LatestPhotosBlock = () => {
  const [images, setImages] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axios.get(`${API_BASE}/latest-photos-per-photographer?limit=12`);
        if (!cancelled) setImages(data.images || []);
      } catch (err) {
        console.error('Failed to load latest photos block:', err);
      } finally {
        if (!cancelled) setLoaded(true);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (!loaded || images.length === 0) return null;

  return (
    <section
      className="max-w-full md:max-w-[70%] mx-auto px-4 py-10"
      data-testid="latest-photos-block"
    >
      <div className="mb-6 featured-block-title">
        <h2>Latest Photos from Mauritius</h2>
        <p>
          Browse the newest photos shared by Explora photographers, from Mauritius beaches
          and mountain views to forests, villages, wildlife, sunsets, and island scenery.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 min-[1920px]:grid-cols-4 gap-6">
        {images.map((img) => (
          <div key={img.id} className="flex flex-col">
            <div className="mb-3 featured-item-title">
              <h3>{img.title}</h3>
            </div>
            <ImageCard
              image={img}
              showPhotographer={true}
              showTags={false}
              photographerClickable={false}
              showLike={false}
              cropToSquare={true}
            />
          </div>
        ))}
      </div>

      <div className="mt-6 flex justify-center">
        <a
          href="/photos"
          className="inline-block px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 text-base rounded transition-colors"
          data-testid="latest-photos-block-cta"
        >
          View all latest Mauritius photos
        </a>
      </div>
    </section>
  );
};

export default LatestPhotosBlock;
